import React from 'react';
import { Spin, Icon, Modal, Button } from 'antd';

export default class Page extends React.Component {
    constructor() {
        super();
    }

    render() {
        let { title, visible, onOk, onCancel, cancelText, width, footer, children, loading, actionRecords, handleAction } = this.props;
        return (
            <Modal
                title={title}
                visible={visible}
                onOk={onOk}
                onCancel={onCancel}
                cancelText={cancelText}
                width={width || 'auto'}
                maskClosable={false}
                footer={
                    footer
                    ||
                    <div>
                        <Button onClick={onOk} type="primary" loading={loading}>确定</Button>
                        <Button onClick={onCancel}>{cancelText ? cancelText : '取消'}</Button>
                    </div>
                }
                destroyOnClose={true}
                centered={true}
            >
                <div style={{ maxHeight: '80vh', overflow: 'auto', padding: '20px' }}>
                    <Spin
                        spinning={loading}
                        indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}
                    >
                        {children}
                    </Spin>
                </div>

                {
                    actionRecords ?
                    <div style={{position: "absolute", bottom: "16px", left: "16px"}}>
                        <span className="showClickDetail" style={{textDecoration: "underline"}} onClick={ handleAction }>操作记录</span>
                        {/* <Button type="primary" icon="reddit" onClick={ handleAction }></Button> */}
                    </div>
                    : null
                }
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Modal/index.js